import { render, staticRenderFns } from "./cuinformation.vue?vue&type=template&id=bd5f2c8a&"
import script from "./cuinformation.vue?vue&type=script&lang=js&"
export * from "./cuinformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports